import { cn } from '@lair-finance/util'
import { DesktopMenuList } from '@/domains/header/config'
import { Link, useLocation } from 'react-router-dom'
import { useMemo } from 'react'
import { useChainId } from '@lair-finance/wagmi'
import { AssetIcon } from '@/shared/ui/Asset'

export function MenuList({ className }: { className?: string }) {
  const location = useLocation()
  const chainId = useChainId()
  const menuList = useMemo(() => DesktopMenuList[chainId], [chainId])

  return (
    <div className={cn('inline-flex-center gap-x-2', className)}>
      {menuList.map(item =>
        item.isExternal ? (
          <a key={item.id} href={item.path} target={'_blank'} className={'group inline-flex'}>
            <MenuItem active={item.isActive(location.pathname)}>
              {item.name}
              <AssetIcon filename={'new-external.png'} size={24} className={'group-hover:hidden'} />
              <AssetIcon filename={'new-external-white.png'} size={24} className={'hidden group-hover:inline-block'} />
            </MenuItem>
          </a>
        ) : (
          <Link key={item.id} to={item.path} className={'inline-flex'}>
            <MenuItem active={item.isActive(location.pathname)}>{item.name}</MenuItem>
          </Link>
        ),
      )}
    </div>
  )
}

function MenuItem({ className, children, active }: { className?: string; children: React.ReactNode; active?: boolean }) {
  return (
    <div
      className={cn(
        'inline-flex items-center px-3 py-2 typo-new-label-2 text-greyscale-300 hover:text-greyscale-100',
        { 'text-greyscale-100': active },
        className,
      )}
    >
      {children}
    </div>
  )
}
